import { ShieldCheck, MapPin, FileCheck2 } from "lucide-react";
import usePageMeta from "@/lib/usePageMeta";
import SectionHead from "@/components/SectionHead";
import { Reveal } from "@/components/Reveal";
import CandidateForm from "@/components/forms/CandidateForm";

const POINTS = [
  { icon: MapPin, text: "Opportunities with leading organisations across India — IT and Non-IT roles" },
  { icon: ShieldCheck, text: "Your profile is handled with complete confidentiality" },
  { icon: FileCheck2, text: "PDF, DOC or DOCX resume, up to 5MB" },
];

export default function Candidates() {
  usePageMeta(
    "Submit Your Resume | Career Opportunities Across India — Talentify",
    "Submit your resume to Talentify and let our recruitment team connect you with relevant IT and Non-IT career opportunities across India."
  );
  return (
    <main>
      <section className="relative overflow-hidden pb-24 pt-40">
        <div className="pointer-events-none absolute inset-0" style={{ background: "radial-gradient(circle at 70% -10%, rgba(99,102,241,0.12), transparent 55%)" }} />
        <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-2">
          <div>
            <SectionHead overline="For Job Seekers" title="Your Next Opportunity Starts Here." testid="candidates-page-heading" />
            <Reveal delay={0.1}>
              <p className="text-base leading-relaxed text-slate-400">
                Explore career opportunities with leading organisations across India. Submit your profile and let our recruitment team connect you with relevant opportunities.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <ul className="mt-8 space-y-5">
                {POINTS.map((p) => (
                  <li key={p.text} className="flex items-start gap-3.5 text-sm text-slate-300">
                    <span className="grid h-9 w-9 shrink-0 place-items-center rounded-xl border border-white/[0.08] bg-white/[0.03] text-indigo-400">
                      <p.icon size={16} />
                    </span>
                    <span className="pt-1.5">{p.text}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
          <Reveal delay={0.15}>
            <div className="glass-card rounded-3xl p-7 sm:p-10">
              <p className="mb-6 font-mono text-[11px] uppercase tracking-[0.25em] text-indigo-400">Submit Your Resume</p>
              <CandidateForm />
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
